<template>
    <v-data-table
        :fixed-header="true"
        :headers="headers"
        :hover="true"
        :item-key="(item) => `row-${item.id}`"
        :items="devices"
        :items-per-page="10"
        class="elevation-1"
        density="compact"
        item-value="id"
    >
        <template v-slot:item.id="{ item }">
            <td :class="`item-${item.value}`">{{ item.value }}</td>
        </template>
        <!-- 'voltage' is the SKU-selected channel in millivolts (live resource + MQTT). -->
        <template v-slot:item.voltage="{ item }">{{ item.voltage != null ? strOperations().formatVoltage(item.voltage) : '' }}</template>
    </v-data-table>
</template>

<script setup>
import {watch} from "vue";
import {strOperations} from "@/composables/globals";

const props = defineProps(['devices', 'headers', 'selected']);

const blinkElementById = (id) => {
    let elem = document.querySelector(`.item-${id}`);
    if (elem) {
        elem.closest('tr').classList.add('blinking-row')
    }

    setTimeout(() => {
        elem.classList.remove('blinking-row')
    }, 2000)
}

// watch(() => props.devices, (val) => {
//     val.forEach((device) => {
//         if (device.diff_in_secs < 10) {
//             blinkElementById(device.id)
//         }
//     })
// })

watch(() => props.selected, (val) => {
    blinkElementById(val)
})
</script>

<style scoped>

</style>
